<style lang="less" scoped>
.rent-plan{
  width: 100%;
  position: relative;
}
</style>

<template>
  <div class="rent-plan" >
    <AntdSpin :spinning="operate" />
    <a-table :dataSource="data" :columns="columns" bordered :pagination="false" :scroll="{ x: width - 10, y: height }" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TableColumnType } from 'ant-design-vue'
import AntdSpin from '@/components/data/AntdSpin.vue'
import overdueApi from '../../api/overdue'

export default defineComponent({
  name: 'RentPlan',
  components: {
    AntdSpin: AntdSpin
  },
  props: {
    id: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      operate: false,
      index: 0,
      data: [] as any[],
      columns: [
        {
          dataIndex: 'planList',
          title: '期数',
          align: 'center',
          width: 80
        },
        {
          dataIndex: 'planDate',
          title: '日期',
          align: 'center',
          width: 180
        },
        {
          dataIndex: 'rent',
          title: '当期应付金额',
          align: 'center',
          width: 160
        },
      ] as TableColumnType[]
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData()
        }
      }
    }
  },
  methods: {
    getData() {
      this.data = []
      this.operate = true
      overdueApi.overdueRentPlan.require({
        contractId: this.id
      }).then(res => {
        this.data = res.data.data
      }).finally(() => {
        this.operate = false
      })
    }
  }
})
</script>
